<script setup lang="ts">
import { useI18n } from "vue-i18n";

import Button from "@/dsComponents/buttons/Button.vue";
import Link from "@/dsComponents/buttons/Link.vue";
import FormSection from "@/dsComponents/FormSection.vue";
import Overlay from "@/dsComponents/modals/Overlay.vue";

withDefaults(
    defineProps<{
        open: boolean;
        title: string;
        maxWidth?: string;
        subtitle?: string;
        loading?: boolean;
        disableConfirm?: boolean;
    }>(),
    {
        maxWidth: "500px",
        disableConfirm: false,
    }
);

const emit = defineEmits<{
    (e: "confirm"): void;
    (e: "cancel"): void;
}>();

const { t } = useI18n();
</script>
<template>
    <Overlay v-if="open" center>
        <div class="modal-confirm" :style="{ maxWidth }">
            <FormSection :title="title" :subtitle="subtitle" />
            <slot />
            <div class="button-container">
                <Link :label="t('global.actions.cancel')" @click="emit('cancel')" underline type="neutral" />
                <Button :label="t('global.actions.confirm')" @click="emit('confirm')" size="sm" :loading="loading" :disabled="disableConfirm" />
            </div>
        </div>
    </Overlay>
</template>
<style scoped lang="scss">
.modal-confirm {
    background-color: white;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    border-radius: 12px;
    box-shadow: 0px 16px 32px -14px rgba(73, 78, 97, 0.1);

    display: flex;
    flex-direction: column;
    gap: 24px;

    padding: 20px 40px;

    text-align: center;
    color: $text-main-900;

    .button-container {
        display: flex;
        width: 100%;
        gap: 16px;
        justify-content: center;
        align-items: center;
    }
}
</style>
